import * as api from '../../api';
import { ALL_CATEGORIES_ID } from './model';
import * as categoryActions from './actions';
import { getSelectedIds as getProjectIds } from '../project/selectors';
import * as lastStateActions from '../lastState/actions';
import { getSelectedId, getExpandedKeys, getCategoriesById } from './selectors';
import { takeLatest } from '../../listenerMiddleware';
import { loadDictionary } from '../filtersCache/loadDictionary';

export const categoryRootListeners = () => {
  watchLoadCategoriesRequested();
  watchLastState();
};

function watchLoadCategoriesRequested() {
  takeLatest(
    categoryActions.loadCategoriesRequested,
    async ({ payload }, { getState, dispatch, signal }) => {
      const projectIds = getProjectIds(getState());

      await loadDictionary(
        {
          dict: 'category',
          params: { projectIds },
          setLoading: categoryActions.setLoading,
          itemsChanged: (categories) => categoryActions.categoriesChanged({ categories }),
          request: () =>
            api.loadCategories(projectIds).then((r) => (r.success ? r.data.response : undefined)),
          errorMessage: 'Categories have not been loaded',
        },
        { getState, dispatch, signal },
      );
      if (signal.aborted) {
        return;
      }

      // Проверки консистентности идут всегда, даже когда сеть была пропущена: выбранная
      // категория и раскрытые ветки могли прийти из lastState и не существовать в дереве.
      const { saveLastState } = payload;

      // Check selected id
      const selectedId = getSelectedId(getState());
      const categoriesById = getCategoriesById(getState());
      if (selectedId !== ALL_CATEGORIES_ID && !categoriesById[selectedId]) {
        dispatch(
          categoryActions.categorySelected({
            id: ALL_CATEGORIES_ID,
            saveLastState,
            log: { category: null },
          }),
        );
      }

      // Check expanded keys
      const expandedKeys = getExpandedKeys(getState());
      const newExpandedKeys = expandedKeys.filter(
        (id) => id === ALL_CATEGORIES_ID || categoriesById[id],
      );
      if (newExpandedKeys.length !== expandedKeys.length) {
        dispatch(categoryActions.setExpandedKeys({ keys: newExpandedKeys, saveLastState }));
      }
    },
  );
}

function watchLastState() {
  takeLatest(
    [categoryActions.categorySelected, categoryActions.setExpandedKeys],
    ({ payload }, { dispatch }) => {
      if (payload.saveLastState) {
        dispatch(lastStateActions.saveRequested());
      }
    },
  );
}
